import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'sp-add-vantaca-credential',
  templateUrl: './add-vantaca-credential.component.html',
  styleUrls: ['./add-vantaca-credential.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddVantacaCredentialComponent {
  @Input() formGroup: FormGroup;
}
